import React from "react";
import './TriCheckBox.css'
import styled, { keyframes } from 'styled-components'
import {Ripple} from 'primereact/ripple'

const state1KeyFrame = keyframes`
    from {
        transform: scale(0, 0) rotate(0deg);
    }

    to {
        transform: scale(1, 1) rotate(-45deg);
    }
`;

const state1KeyFramePart1 = keyframes`
    from {
        transform: scale(0, 0) rotate(-45deg);
        transform-origin: center right;
    }

    to {
        transform: scale(1, 1) rotate(-45deg);
        transform-origin: center right;
    }
`;

const state2KeyFramePart2 = keyframes`
    0% {
        transform: scale(0, 0) rotate(45deg);
    }
    40% {
        transform: scale(0, 0) rotate(45deg);
        transform-origin: center right;
    }
    100% {
        transform: scale(1, 1) rotate(45deg);
        transform-origin: center right;
    }
`;

const State1 = styled.div`
    width: 100%;
    height: 15%;
    border-radius: 8px;
    transform: rotate(-45deg);
    background-color: white;
    animation: ${state1KeyFrame} 200ms ease-in forwards;
`;

const State2First = styled.div`
    position: absolute;
    left: 14%;
    top: 19%;
    width: 70%;
    height: 20%;
    border-radius: 8px;
    background-color: white;
    animation: ${state1KeyFramePart1} 200ms ease-in forwards;
`;

const State2Second = styled.div`
    position: absolute;
    top: 65%;
    left: 5%;
    width: 40%;
    height: 20%;
    border-radius: 8px;
    background-color: white;
    animation: ${state2KeyFramePart2} 300ms ease-in forwards;
`;

export default class TriCheckBox extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    getBackgroundColor() {
        if(this.props.value === 0) {
            return this.props.disabled ? "#eee" : "none";
        }
        else if(this.props.value === 1)
        {
            return this.props.disabled ? "#D1BDB1" : "#FFA366";
        }
        else if(this.props.value === 2) 
        {
            return this.props.disabled ? "#ADD8B3" : "#4FB55E";
        }
        return "none";
    }

    getBorder() {
        if(this.props.value === 0)
            return "2px solid #aaa";
        return "2px solid " + this.getBackgroundColor();
    }

    

    render() {
        return (
            <button disabled={this.props.disabled} className={"p-ripple tri" + this.props.value} onClick={() => this.props.onChange(this.props.value === 2 ? 0 : this.props.value + 1)}
                style={{margin: "4px", width: "30px", height: "30px", backgroundColor: "none", background:
                this.getBackgroundColor(), borderRadius: "12px", transition: "500ms", border: this.getBorder()}}
            >
                <Ripple />
                {this.props.value === 1 &&
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
                        <State1 />
                    </div>
                }
                {this.props.value === 2 && 
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
                        <State2First />
                        <State2Second />
                    </div>
                }
            </button>
        )
    }
}